import { render } from "./ModalApplyForLeave.vue?vue&type=template&id=28d15b64"
import script from "./ModalApplyForLeave.vue?vue&type=script&lang=js"
export * from "./ModalApplyForLeave.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__